import { render, staticRenderFns } from "./subscriptionhistory.vue?vue&type=template&id=bddb8022&scoped=true&"
import script from "./subscriptionhistory.vue?vue&type=script&lang=js&"
export * from "./subscriptionhistory.vue?vue&type=script&lang=js&"
import style0 from "./subscriptionhistory.vue?vue&type=style&index=0&id=bddb8022&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bddb8022",
  null
  
)

export default component.exports